import 'whatwg-fetch';
import { browserHistory } from 'react-router';
import { ACTION_TYPE } from '../constants';
import { handleError } from './common';
import { initVerificationAction } from './verification';

/*
	Actions
*/
function initRealinfoAction(data) {
	return {
		type: 'INIT_REALINFO',
		data: data,
	};
}

function saveRealinfoAction(data) {
	return {
		type: 'SAVE_REALINFO',
		data: data,
	};
}

function updateRealinfoAction(data) {
	return {
		type: 'UPDATE_REALINFO',
		data: data,
	};
}

/*
	Async functions
*/
export function initRealinfo() {
	return (dispatch) => {
		fetch('/api/account/realinfo/init', { credentials: 'same-origin' })
			.then((response) => response.json())
			.then((data) => handleInitRealinfo(dispatch, data));
	};
}

export function saveRealinfo(realname, idcard, birthday, encryptedPassword) {
	return (dispatch) => {
		fetch('/api/account/realinfo/save', {
			credentials: 'same-origin',
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify({
				realname: realname,
				idcard: idcard,
				birthday: birthday,
				password: encryptedPassword,
			}),
		})
			.then((response) => response.json())
			.then((data) => handleSaveRealinfo(dispatch, data));
	};
}

export function initUpdateRealinfo() {
	return (dispatch) => {
		fetch('/api/account/realinfo/update/init', {
			credentials: 'same-origin',
		})
			.then((response) => response.json())
			.then((data) => handleUpdateRealinfo(dispatch, data));
	};
}

export function updateRealinfo(realname, idcard) {
	return (dispatch) => {
		fetch('/api/account/realinfo/update', {
			credentials: 'same-origin',
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify({
				realname: realname,
				idcard: idcard,
			}),
		})
			.then((response) => response.json())
			.then((data) => handleUpdateRealinfo(dispatch, data));
	};
}

/*
 Helper functions
 */
function handleInitRealinfo(dispatch, data) {
	if ('error' in data) {
		handleError(data);
		return;
	}
	switch (data.next_action.action_type) {
		case ACTION_TYPE.APPLY_EMAIL:
			browserHistory.push('/security/realinfo/no_email');
			break;
		case ACTION_TYPE.VERIFY_EMAIL:
			browserHistory.push('/security/realinfo/unverified_email');
			break;
		case ACTION_TYPE.TWO_STEP_VERIFICATION:
			dispatch(initVerificationAction(data));
			browserHistory.push('/security/realinfo/2-step-verification');
			break;
		case ACTION_TYPE.SAVE_REALINFO:
			dispatch(initRealinfoAction(data));
			browserHistory.push('/security/realinfo/save');
			break;
		default:
			break;
	}
}

function handleSaveRealinfo(dispatch, data) {
	if ('error' in data) {
		handleError(data);
		return;
	}
	if (
		data.status === 0 &&
		data.next_action.action_type === ACTION_TYPE.DONE
	) {
		browserHistory.push('/security/realinfo/done');
	}
	dispatch(saveRealinfoAction(data));
}

function handleUpdateRealinfo(dispatch, data) {
	if ('error' in data) {
		handleError(data);
		return;
	}
	switch (data.next_action.action_type) {
		case ACTION_TYPE.TWO_STEP_VERIFICATION:
			dispatch(initVerificationAction(data));
			browserHistory.push('/security/realinfo/2-step-verification');
			break;
		case ACTION_TYPE.UPDATE_REALINFO:
			dispatch(updateRealinfoAction(data));
			browserHistory.push('/security/realinfo/update');
			break;
		case ACTION_TYPE.DONE:
			browserHistory.push('/security/realinfo/done');
			break;
		default:
			break;
	}
}



// WEBPACK FOOTER //
// ./app/actions/realinfo.js